import { DropTargetEvent } from "@progress/kendo-angular-utils";
import { GroupResult } from '@progress/kendo-data-query';

//See example code: https://www.telerik.com/kendo-angular-ui/components/grid/rows/reordering#dragging-the-row

export const calculateDestinationIndex = (
  e: DropTargetEvent,
  fromGrid: number,
  fromIndex: number,
  toGrid: number
): number => {
  let toIndex = Number(e.dropTarget.getAttribute("data-kendo-grid-item-index") ?? -1);
  const isInLowerHalf = isDroppedInLowerHalf(e);

  if (fromGrid !== toGrid) {
    if (isInLowerHalf) {
      toIndex += 1;
    }
  } else {
    if (isInLowerHalf && fromIndex > toIndex) {
      toIndex += 1;
    } else if (!isInLowerHalf && fromIndex < toIndex) {
      toIndex -= 1;
    }
  }
  return toIndex;
};

export const calculateDestinationIndexWithGroups = (
  e: DropTargetEvent,
  fromIndex: number,
  gridData: GroupResult[]
): GroupDragAndDropDestinationResult => {
  const result: GroupDragAndDropDestinationResult = {
    fromGroupIndex: -1,
    fromGroupItemIndex: -1,
    toGroupIndex: -1,
    toGroupItemIndex: -1,
  };
  const toIndex = Number(e.dropTarget.getAttribute("data-kendo-grid-item-index") ?? -1);
  const isInLowerHalf = isDroppedInLowerHalf(e);
  const items: object[] = gridData.flatMap(g => g?.items);

  //First get original items in grid
  const fromItem = items[fromIndex];
  const toItem = items[toIndex];
  result.fromGroupIndex = gridData.findIndex(g => g.items.includes(fromItem));
  result.toGroupIndex = gridData.findIndex(g => g.items.includes(toItem));
  result.fromGroupItemIndex = gridData[result.fromGroupIndex].items.indexOf(fromItem);
  result.toGroupItemIndex = gridData[result.toGroupIndex].items.indexOf(toItem);

  if (isInLowerHalf && fromIndex > toIndex) {
    result.toGroupItemIndex += 1;
  } else if (!isInLowerHalf && fromIndex < toIndex) {
    result.toGroupItemIndex -= 1;
  }

  return result;
};

export const isDroppedInLowerHalf = (ev: DropTargetEvent) => {
  const itemCoords = ev.dropTarget.getBoundingClientRect();
  return ev.dragEvent.clientY > itemCoords.top + itemCoords.height / 2;
};

export interface GroupDragAndDropDestinationResult {
  fromGroupIndex: number;
  fromGroupItemIndex: number;
  toGroupIndex: number;
  toGroupItemIndex: number;
}
